/* eslint-disable import/prefer-default-export */

export const heightReflowOptions = {
  property: 'height',
  transition: 'height 300ms cubic-bezier(0.77, 0, 0.175, 1)',
};
